import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { SalaryDraftFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { SalaryDraftForwardFormContainerProps } from "models/propTypes/salaryPropTypes";
import * as Yup from "yup";
//#endregion
//#region components
import SalaryDraftForwardForm from "./forwardForm";
import { useSalaryService } from "serviceHooks";
//#endregion

const SalaryDraftForwardFormContainer: ForwardRefRenderFunction<FormHandles, SalaryDraftForwardFormContainerProps> = (
  props,
  ref
) => {
  const salaryService = useSalaryService();
  const validationSchema = Yup.object<SalaryDraftFormTypes.Assign>({
    message: Yup.string().required(TranslationKeys.Validations.Required),
    assignPersonId: Yup.number().required(TranslationKeys.Validations.Required),
    assignPersonName: Yup.string().required(TranslationKeys.Validations.Required),
  });

  const handleSubmit = async (values: SalaryDraftFormTypes.Assign) => {
    if (values.assignPersonId)
      return salaryService.assignSalaryDraft(props.salaryDraftId, {
        salaryDraftAssigneeId: values.assignPersonId,
        message: values.message,
      });
  };

  return (
    <SalaryDraftForwardForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={{}}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(SalaryDraftForwardFormContainer);
